import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/components/ui/table';
import { Button } from '~/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ILeadSourceRow } from '~/types';

interface ILeadSourceTableProps {
  rows: ILeadSourceRow[];
  total: number;
  page: number;
  onPageChange: (page: number) => void;
}

const PAGE_SIZE = 25;

export const LeadSourceTable = ({ rows, total, page, onPageChange }: ILeadSourceTableProps) => {
  const totalPages = Math.ceil(total / PAGE_SIZE);

  return (
    <div>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Source</TableHead>
              <TableHead className="text-right">Total Leads</TableHead>
              <TableHead className="text-right">Partial Submissions</TableHead>
              <TableHead className="text-right">Forms Completed</TableHead>
              <TableHead className="text-right">Meetings Booked</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="h-24 text-center text-muted-foreground">
                  No lead sources found
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow key={row.source}>
                  <TableCell className="font-medium">{row.source}</TableCell>
                  <TableCell className="text-right">{row.totalLeads}</TableCell>
                  <TableCell className="text-right">{row.partialSubmissions}</TableCell>
                  <TableCell className="text-right">{row.formsCompleted}</TableCell>
                  <TableCell className="text-right">{row.meetingsBooked}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-between mt-4">
          <p className="text-sm text-muted-foreground">
            Showing {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, total)} of {total}
          </p>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <span className="text-sm">
              Page {page} of {totalPages}
            </span>
            <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
